<script setup lang="ts">
import type { LoyaltyMerchantFormConfig } from '@/types/global'

const { t } = useI18n()
const props = defineProps<{
  item: LoyaltyMerchantFormConfig
  index: number
}>()

const field = ref(props.item)

watch(props.item, () => (field.value = props.item))
</script>

<template>
  <div v-if="field?.type === 'toggle'">
    <div v-if="field.tooltip" class="flex justify-between">
      <label :for="field.label" class="mb-3 block text-sm font-medium text-foreground">{{ field.label }}</label>
      <div>
        <AppTooltip tooltip-position="left" :text="field.tooltip.text">
          <BaseIcon
            name="HeroExclamationCircleIconOutline"
            class="mr-2 h-5 w-5 rotate-180 transform cursor-pointer text-foreground-secondary"
          />
        </AppTooltip>
      </div>
    </div>

    <label v-else :for="field.label" class="mb-3 block text-sm font-medium text-foreground">{{ field.label }}</label>
    <div class="flex items-center">
      <BaseSwitch
        id="hasPointsByCurrencyUnit"
        v-model="field.value"
        :label="field.value ? t('global.words.enabled') : t('global.words.disabled')"
        font-color-gradient="600"
        :font-color="field.value ? 'green' : 'red'"
      />
    </div>
  </div>
  <div v-else-if="field?.label">
    <AppFormInput
      :id="field.label"
      v-model="field.value"
      :label="field?.label"
      :type="field.type"
      :name="field.label"
      :required="field.required"
      :min="field.min"
      :max="field.max"
    />
  </div>
</template>
